import React from 'react';
import { Text } from '@fragments';
import { IconAlertTriangle, IconMovie, IconX } from '@tabler/icons-react';
import './styles.scss';

// The picker's footer: three minimized 9:16 slots, then what they hold (title + detail),
// then the actions. The slots show the choice as it is made, each removable. Before one is
// made, they show the Reels the active personality was mapped from. A slot a failed mapping
// marked to swap keeps its cover, dimmed under an alert, until a pick takes its place.
export default function ReelTray({ t, slots, items, removable = false, onRemove, title, detail, children }) {
  return <div className="studio-reel-tray">
    <div className="studio-reel-tray__choice">
      <ol className="studio-reel-tray__slots" aria-label={title}>
        {Array.from({ length: slots }, (_, index) => {
          const item = items[index];
          const failed = !!item?.failed;
          return <li key={item?.id || `slot-${index}`} className={`studio-reel-tray__slot${item ? ' is-filled' : ''}${failed ? ' is-failed' : ''}`}
            aria-label={failed ? t('personalitySlotFailed', { position: index + 1, reason: item.failed }) : undefined}>
            {item ? <>
              {item.cover ? <img src={item.cover} alt={failed ? '' : item.label || ''} draggable={false} /> : <IconMovie aria-hidden="true" />}
              {failed && <span className="studio-reel-tray__alert" aria-hidden="true"><IconAlertTriangle /></span>}
              {removable && <button type="button" className="studio-reel-tray__remove" aria-label={t('personalityRemove', { position: index + 1 })} onClick={() => onRemove(item.id)}><IconX aria-hidden="true" /></button>}
            </> : <Text.caption contrast={5} aria-hidden="true">{index + 1}</Text.caption>}
          </li>;
        })}
      </ol>
      <div className="studio-reel-tray__text" aria-live="polite">
        {title && <Text.label contrast={9}>{title}</Text.label>}
        {detail}
      </div>
    </div>
    <div className="studio-reel-tray__actions">{children}</div>
  </div>;
}
